import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cellphonePipe'
})
export class CellphonePipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return '--';

        const cleaned = value.replace(/\D/g, '');

        if (cleaned.length === 11) {
            return `(${cleaned.substring(0, 2)}) ${cleaned.substring(2, 7)}-${cleaned.substring(7, 11)}`;
        }

        if (cleaned.length === 10) {
            return `(${cleaned.substring(0, 2)}) ${cleaned.substring(2, 6)}-${cleaned.substring(6, 10)}`;
        }

        return value;
    }
}